import { idFromGlobalId } from './GlobalIdUtil';
export function getAssignableProfiles(profiles) {
    return profiles.filter(profile => idFromGlobalId(profile.id) !== -2 && idFromGlobalId(profile.id) !== -3 && !profile.disable);
}
